export { default } from './LazyPendingSkills';
